import GridTemplate, { GridTemplateProps } from './GridTemplate';

const ListTemplate = (props: GridTemplateProps) => {
  return <GridTemplate {...props} list={true} />;
};

export default ListTemplate;
